import React, { Component, Fragment } from 'react';
import { Row, Col, Button, Card, CardBody, Table, Label, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { GridLoader } from 'react-spinners';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import {
    CASH_ID,
    COLLECTION_ID,
    DELIVERY_ID,
    INSTORE_ID,
    REJECTED,
    ACCEPTED,
    US,
    CA,
    CURBSIDE_ID,
    ACEPTADO
} from '../../../utils/Constants';
import {
    calculateDiscount,
    getMaxRefundAmount,
    getPriceWithCurrencySymbol,
    localizeCountryNames,
    renderOrderTypeSrc,
    renderPaymentTypeIcon,
    transformProductPrice,
    transformProductsComingFromServer
} from '../../../utils/CommonUtils';
import RestaurantUtils from '../../../utils/RestaurantUtils';

import OrderSourceSelector from '../../common/OrderSourceSelector';
/**TODO refactor this and the other screens that will be using it */
class OrderDetailsContent extends Component {
    constructor() {
        super();

        this.state = {
            extraTime: '5',
            refundType: 'Full',
            cancelRefundReason: 'WE_ARE_TOO_BUSY',
            isCancelOrderExpanded: false,
            rejectedOrderStatusReceived: null,
            resendOrderConfirmationModalOpened: false,
        }

        this.changeState = this.changeState.bind(this);
        this.onClickAddExtraTime = this.onClickAddExtraTime.bind(this);
    }

    changeState({ target }) {
        if (target.name === 'refundType' && target.value === 'Full') {
            this.setState({ ...this.state, [target.name]: target.value, refundValue: '' });
        } else {
            this.setState({ ...this.state, [target.name]: target.value });
        }
    }

    toggleResendOrderConfirmationModal(orderId) {
        this.setState({
            ...this.state,
            resendOrderConfirmationModalOpened: !this.state.resendOrderConfirmationModalOpened,
            resetOrderId: (orderId) ? orderId : null
        });
    }

    toggleAcceptOrderConfirmationModal(orderId) {
        this.setState({
            ...this.state,
            acceptOrderConfirmationModalOpened: !this.state.acceptOrderConfirmationModalOpened,
            acceptOrderId: (orderId) ? orderId : null
        });
    }

    resendOrder(orderId) {
        this.setState({ ...this.state, loading: true }, () => {

            this.props.resendFailedOrder(orderId, (orderStatus) => {
                if (orderStatus) {
                    this.setState({ ...this.state, rejectedOrderStatusReceived: orderStatus, loading: false }, () => this.toggleResendOrderConfirmationModal());
                    this.props.rejectedOrderReseted();
                } else {
                    this.setState({ ...this.state, loading: false }, () => this.toggleResendOrderConfirmationModal());
                }
            });
        });
    }

    renderCustomerDetails() {
        const { screenTitleContainer, labelStyle, spanStyle } = styles;
        const customer = this.props.orderDetails.order.customer;

        return (
            <Col xs={6} sm={6} md={6}>
                <Col xs={6} style={screenTitleContainer}>
                    <div><MaterialIcon icon="person" color="#0288d1" />{i18n.t('screens:orderDetailsScreen.customerDetails')}</div>
                </Col>
                <Card>
                    <CardBody>
                        <p style={labelStyle}>{i18n.t('common:form.name')}: <span style={spanStyle}> {customer.name}</span></p>
                        <p style={labelStyle}>{i18n.t('common:form.phone')}: <span style={spanStyle}> {customer.phone}</span></p>
                        <p style={labelStyle}>{i18n.t('common:form.email')}: <span style={spanStyle}> {customer.email}</span></p>
                        <p style={labelStyle}>{i18n.t('common:form.country')}: <span style={spanStyle}> {customer.countryCode === CA || customer.countryCode === US ? i18n.t('common:languages.northAmerica') : localizeCountryNames(customer.countryCode)}</span></p>
                    </CardBody>
                </Card>
            </Col>
        );
    }

    renderRestaurantDetails() { /**TODO needs refactoring cuz now won't show at all - most probably this data comes from another service
    and is poured into the reducer */
        const { screenTitleContainer, spanStyle, labelStyle } = styles;
        const restaurant = this.props.orderDetails.restaurantDetails;
        const restaurantAddress = restaurant.address;
        const address = (restaurant.displayAddress !== null) ? restaurant.displayAddress : restaurantAddress.street + ', ' + restaurantAddress.city + ', ' + localizeCountryNames(restaurantAddress.country);

        if (Object.keys(this.props.orderDetails.restaurantDetails).length > 0) {

            return (
                <Col xs={6} sm={6} md={6}>
                    <Col xs={6} style={screenTitleContainer}>
                        <div><MaterialIcon icon="restaurant_menu" color="#0288d1" />{i18n.t('screens:orderDetailsScreen.restaurantDetails')}</div>
                    </Col>
                    <Card>
                        <CardBody>
                            <p style={labelStyle}>{i18n.t('common:form.name')}: <span style={spanStyle}> {restaurant.name}</span></p>
                            <p style={labelStyle}>{i18n.t('common:form.phone')}: <span style={spanStyle}> {restaurant.phone}</span></p>
                            <p style={labelStyle}>{i18n.t('common:form.email')}: <span style={spanStyle}> {restaurant.email}</span></p>
                            <p style={labelStyle}>{i18n.t('common:form.address')}: <span style={spanStyle}>{address}</span></p>
                        </CardBody>
                    </Card>
                </Col>
            );
        }
    }

    renderProductsDetails() {
        const order = this.props.orderDetails.order;
        const products = order.orderProducts;

        return (
            <Table responsive>
                <thead>
                    <tr className="d-flex">
                        <th className="col-4">{i18n.t('screens:orderDetailsScreen.items')}</th>
                        <th className="col-6">{i18n.t('screens:orderDetailsScreen.contains')}</th>
                        <th className="col-1">{i18n.t('screens:orderDetailsScreen.quantity')}</th>
                        <th className="col-1">{i18n.t('screens:orderDetailsScreen.price')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderOrderProducts(products)}
                </tbody>
            </Table>
        );
    }

    renderOrderProducts(products) {
        const { textAlignCenter, mealDealName, priceStyle, instructionsStyle } = styles;
        const orderProducts = transformProductsComingFromServer(products);
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.order.currency;

        return orderProducts.map(product => {

            if (product.length >= 1) {  //MEAL DEAL
                let mealDeal = product.slice(0, 1);
                let mealDealProducts = product.slice(1);
                const mealDealPrice = transformProductPrice(mealDeal[0].totalPrice);
                const mealDealPriceWithCurrency = getPriceWithCurrencySymbol(mealDealPrice, currency);

                return (
                    <tr key={product.id} className="d-flex">
                        <td className="col-4">
                            <p>{mealDeal[0].name}</p>
                        </td>
                        <td className="col-6" style={{ marginBottom: 0 }}>
                            {
                                mealDealProducts.map((mealDealProduct) => {

                                    return (
                                        <div>
                                            <br />
                                            <p style={{ marginBottom: 2 }}>{mealDealProduct.name}</p>
                                            {mealDealProduct ? this.renderProductQuestions(mealDealProduct) : null}
                                            <p style={instructionsStyle}>{(mealDealProduct.instruction !== null) ? <i>"{mealDealProduct.instruction.notes}"</i> : ''}</p>
                                        </div>
                                    );
                                })
                            }
                        </td>
                        <td className="col-1" style={textAlignCenter}>{mealDeal[0].quantity}</td>
                        <td className="col-1">{mealDealPriceWithCurrency}</td>
                    </tr>
                );
            } else {

                return (
                    <tr key={`key${product.id}`} className="d-flex">
                        <td className="col-4">{product.name} {(product.sizeName !== null) ? ' ' + product.sizeName : ''}</td>
                        <td className="col-6" style={{ marginBottom: 0 }}>
                            <p>{this.renderProductQuestions(product)}</p>
                            <p style={instructionsStyle}>{(product.instruction !== null) ? <i>"{product.instruction.notes}"</i> : ''}</p>
                        </td>
                        <td className="col-1" style={textAlignCenter}>{product.quantity}</td>
                        <td className="col-1">{this.renderProductPrice(product)}</td>
                    </tr>
                );
            }
        });
    }

    renderProductQuestions(product) {
        const orderQuestions = product.orderQuestions;

        return orderQuestions.map((question) => {
            const orderAnswers = (question.orderAnswers.length > 0) ? question.orderAnswers : null;

            return (
                <p key={question.id} style={{ marginBottom: 2, fontSize: 12 }}>{this.getQuestionAnswers(question, orderAnswers)}</p>
            );
        });
    }

    getQuestionAnswers(question, orderAnswers) {
        let answers = '';
        let removedAnswers = '';

        if (question.posDefault == true) {
            // Guard orderAnswers when it is null
            if (!orderAnswers) orderAnswers = [];

            orderAnswers.map((answer) => {
                if (answer.quantity > 1) {
                    answers += answer.name + '(' + answer.quantity + '), ';
                }
            });

            if (question.removedAnswers !== null && question.removedAnswers.length > 0) {
                question.removedAnswers.map((аnswer) => {
                    removedAnswers += 'No ' + аnswer.name + ', ';
                });
            }

            return answers.slice(0, -2) + ' ' + removedAnswers.slice(0, -2);
        } else if (orderAnswers !== null && orderAnswers.length > 0) {
            orderAnswers.map((answer) => {
                if (answer.quantity == 1) {
                    answers += i18n.t('screens:orderDetailsScreen.extra') + ' ' + answer.name + ', ';
                } else if (answer.quantity > 1) {
                    answers += i18n.t('screens:orderDetailsScreen.extra') + ' ' + answer.name + '(' + answer.quantity + '), ';
                }
            });

            return answers.slice(0, -2);
        }
    }

    renderProductPrice(product) {
        const productPrice = (product.quantity > 1) ? product.price * product.quantity : product.price;
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.order.currency;
        const prodPrice = transformProductPrice(productPrice);
        const productPriceWithCurrency = getPriceWithCurrencySymbol(prodPrice, currency);

        if (product.promotionFreeProduct) {
            return (
                <span>{i18n.t('screens:orderDetailsScreen.free')}</span>
            );
        } else {
            return (
                <span>{productPriceWithCurrency}</span>
            );
        }
    }

    renderOrderDetails() {
        const { discountTh } = styles;
        const { order } = this.props.orderDetails;
        let vat;

        vat = order.totalTax ? order.totalTax : 0;

        const acceptedTimeStyle = { padding: '18px 2px', paddingLeft: 12 };
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.order.currency;
        const orderServiceFee = order.serviceFee ? order.serviceFee : 0;
        const totalPrice = transformProductPrice(parseFloat(order.total) + orderServiceFee);
        const totalPriceWithCurrency = getPriceWithCurrencySymbol(totalPrice, currency);
        const vatPrice = transformProductPrice(vat);
        const vatPriceWithCurrency = getPriceWithCurrencySymbol(vatPrice, currency);
        const tipPrice = getPriceWithCurrencySymbol(order.tip, currency);

        let discountPrice = transformProductPrice(order.discount);

        let discountPriceWithCurrency = '';
        if (currency !== 'bgn' && discountPrice < 0) {
            discountPrice = discountPrice * -1;
            discountPriceWithCurrency = `-${getPriceWithCurrencySymbol(discountPrice, currency)}`;
        } else {
            discountPriceWithCurrency = getPriceWithCurrencySymbol(discountPrice, currency);
        }

        return (
            <Table responsive>
                <thead>
                    <tr className="d-flex">
                        <th className="col-2">{i18n.t('screens:orderDetailsScreen.totalPrice')}</th>
                        <th className="col-1">{i18n.t('screens:orderDetailsScreen.vat')}</th>
                        <th className='col-1'>{i18n.t('screens:orderDetailsScreen.deposit')}</th>
                        <th className="col-1" style={discountTh}>{order.paidWithVoucher ?
                            i18n.t('screens:restaurantsMainContainer.loyalty')
                            :
                            i18n.t('screens:orderDetailsScreen.discountPrice')}
                        </th>
                        <th className='col-1'>{i18n.t('screens:orderDetailsScreen.tip')}</th>
                        {
                            order.serviceFee ?
                                <th className={!order.deliveryCharge ? 'col-2' : 'col-1'}>{i18n.t('screens:orderDetailsScreen.fee')}</th> : null
                        }
                        {
                            order.deliveryCharge ?
                                <th className={!order.serviceFee ? 'col-2' : 'col-1'}>{i18n.t('screens:orderDetailsScreen.deliveryCharge')}</th> : null
                        }
                        <th className={!order.serviceFee && !order.deliveryCharge ? 'col-3' : "col-2"}>{i18n.t('screens:orderDetailsScreen.placedTime')}</th>
                        <th className={!order.serviceFee && !order.deliveryCharge ? 'col-3' : "col-2"}>{i18n.t('screens:orderDetailsScreen.promisedTime')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="d-flex">
                        <td className="col-2">{totalPriceWithCurrency}</td>
                        <td className="col-1">{vatPriceWithCurrency}</td>
                        <td className='col-1'>{getPriceWithCurrencySymbol(transformProductPrice(order.orderDeposit), currency)}</td>
                        <td className="col-1">{discountPriceWithCurrency}</td>
                        <td className="col-1">{tipPrice}</td>
                        {
                            order.serviceFee ?
                                <td className={!order.deliveryCharge ? 'col-2' : 'col-1'}>{getPriceWithCurrencySymbol(transformProductPrice(order.serviceFee), currency)}</td> : null
                        }
                        {
                            order.deliveryCharge ?
                                <td className={!order.serviceFee ? 'col-2' : 'col-1'}>{getPriceWithCurrencySymbol(transformProductPrice(order.deliveryCharge), currency)}</td> : null
                        }
                        <td className={!order.serviceFee && !order.deliveryCharge ? 'col-3' : "col-2"} style={acceptedTimeStyle}>{order.placedTime}</td>
                        <td className={!order.serviceFee && !order.deliveryCharge ? 'col-3' : "col-2"} style={acceptedTimeStyle}>{(order.acceptedTime == null) ? (order.wantedTime == null) ? '------------' : order.wantedTime : order.acceptedTime}</td>
                    </tr>
                </tbody>
            </Table>
        );
    }

    renderRefundDetails() {
        const { alignLeft, refundDetailsContainer, negativeMarginRight, noLeftRightMargin, totalPriceContainer, totalPriceLabel, refundTypeContainer, priceStyle,
            refundTypeLabel, refundValueContainer, refundValueLabel, refundReasonContainer, refundReasonColumn, refundReasonLabel } = styles;
        const { order } = this.props.orderDetails;
        const refunds = this.props.orderDetails.refunds;
        const orderTotal = order.total + (order.serviceFee ? order.serviceFee : 0);
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.order.currency;
        const maxRefundAmount = transformProductPrice(getMaxRefundAmount(orderTotal, refunds));
        const isRefundDisabled = (maxRefundAmount == 0) ? true : false;
        const isRefundHidden = (order.tenderType.id == CASH_ID || order.status == 'CANCELED' || order.status == 'REFUNDED') ? true : false;
        const priceTotal = transformProductPrice(orderTotal);
        const priceTotalWithCurrency = getPriceWithCurrencySymbol(priceTotal, currency);
        const maxRefundAmountWithCurrency = getPriceWithCurrencySymbol(maxRefundAmount, currency);

        return (
            <Col xs={12} sm={12} md={12} style={refundDetailsContainer} hidden={isRefundHidden}>
                <Card style={negativeMarginRight}>
                    <CardBody style={negativeMarginRight}>
                        <Row style={noLeftRightMargin}>
                            <Col xs={12} sm={4} style={totalPriceContainer}>
                                <p style={totalPriceLabel}>{order.loyaltyDiscount ? i18n.t('screens:orderDetailsScreen.priceLabelNoLoyalty') : i18n.t('screens:orderDetailsScreen.priceLabel')}: <span style={priceStyle}>{priceTotalWithCurrency}</span></p>
                            </Col>
                            <Col xs={12} sm={4} style={refundTypeContainer}>
                                <span style={refundTypeLabel}>{i18n.t('screens:orderDetailsScreen.refundType')}: </span>
                                <Input type="select" name="refundType" id="refundType" placeholder={i18n.t('screens:orderDetailsScreen.refundType')}
                                    value={this.state.refundType}
                                    onChange={this.changeState}>
                                    <option value="Full">{i18n.t('screens:orderDetailsScreen.full')}</option>
                                    <option value="Part">{i18n.t('screens:orderDetailsScreen.part')}</option>
                                </Input>
                            </Col>
                            <Col xs={12} sm={4} style={refundValueContainer}>
                                <span style={refundValueLabel}>{i18n.t('screens:orderDetailsScreen.refundValue')}</span>
                                <Input type="number" name="refundValue"
                                    placeholder={'up to ' + maxRefundAmountWithCurrency}
                                    max={maxRefundAmount}
                                    min={1}
                                    disabled={this.state.refundType === 'Full'}
                                    value={this.state.refundValue}
                                    onChange={this.changeState} />
                            </Col>
                        </Row>
                        <Row style={refundReasonContainer}>
                            <Col xs={12} sm={10} style={refundReasonColumn}>
                                <span style={refundReasonLabel}>{i18n.t('screens:orderDetailsScreen.refundReason')}: </span>
                                <Input type="textarea" name="refundReason" id="refundReason" placeholder={i18n.t('screens:orderDetailsScreen.typeRefundReason')}
                                    value={this.state.refundReason} onChange={this.changeState} required={true} />
                            </Col>
                            <Col xs={12} sm={2} style={alignLeft}>
                                <Button color="primary" disabled={isRefundDisabled} onClick={() => this.doRefund()} style={{ paddingLeft: 10 }} >{i18n.t('screens:orderDetailsScreen.doRefund')}</Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        );
    }

    doRefund() {
        const orderId = this.props.orderDetails.order.id;
        const refundData = {
            amount: (this.state.refundValue == 0 || this.state.refundValue == null) ? null : Number(this.state.refundValue),
            reason: this.state.refundReason
        };
        const restaurantId = this.props.restaurantId ? this.props.restaurantId : this.props.match.params.restaurantId;
        const currentPageNumber = this.props.currentPageNumber;

        this.props.refund(refundData, orderId, restaurantId, currentPageNumber, () => {
            // this.toggle();

            // if (this.props.searchQuery) {
            //     this.props.getOrdersCentral(0, this.props.searchQuery);
            // }
        }, 'ordersLink');
    }

    renderRefundHistoryDetails() {
        const refunds = this.props.orderDetails.refunds;
        const order = this.props.orderDetails.order;
        const isRefundHistoryHidden = (order.tenderType.id == 2) ? true : false;

        return (
            <Col xs={12} sm={12} md={12} style={{ paddingLeft: 0, float: 'left', marginBottom: 15 }} hidden={isRefundHistoryHidden}>
                <Table responsive>
                    <thead>
                        <tr className="d-flex">
                            <th className="col-3">{i18n.t('screens:orderHistoryScreen.date')}</th>
                            <th className="col-3">{i18n.t('screens:orderDetailsScreen.amount')}</th>
                            <th className="col-6">{i18n.t('screens:orderDetailsScreen.reason')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(refunds.length > 0) ? this.renderRefundHistory(refunds) : <p style={{ padding: 12 }}>{i18n.t('screens:orderDetailsScreen.noRefundHistory')}</p>}
                    </tbody>
                </Table>
            </Col>
        );
    }

    renderRefundHistory(refunds) {
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.order.currency;

        return refunds.map((refund) => {
            const refundAmount = transformProductPrice(refund.amount);
            const refundAmountWithCurrency = getPriceWithCurrencySymbol(refundAmount, currency);

            return (
                <tr className="d-flex">
                    <td className="col-3">{refund.date}</td>
                    <td className="col-3">{refundAmountWithCurrency}</td>
                    <td className="col-6">{refund.reason}</td>
                </tr>
            );
        });
    }

    renderCancelOrder() {
        const { cancelOrderContainer, cardBodyMainColumn, cancelRefundReasonColumn, leftAlignedLabel, noPadding, alignRight } = styles;
        const order = this.props.orderDetails.order;
        const isCancelOrderHidden = (order.status == 'CANCELED') ? true : false;

        return (
            <Col xs={12} sm={12} md={12} style={cancelOrderContainer} hidden={isCancelOrderHidden}>
                <Card>
                    <CardBody>
                        <Col xs={12} sm={12} style={cardBodyMainColumn}>
                            <Col sm={7} style={cancelRefundReasonColumn}>
                                <p style={leftAlignedLabel}>{i18n.t('screens:orderDetailsScreen.cancelReason')}:</p>
                                <Input type="select" name="cancelRefundReason" id="cancelRefundReason"
                                    value={this.state.cancelRefundReason}
                                    onChange={this.changeState}>
                                    <option value="WE_ARE_TOO_BUSY">{i18n.t('screens:orderDetailsScreen.tooBusyMsg')}</option>
                                    <option value="DELIVERY_NOT_AVAILABLE_AT_THIS_TIME">{i18n.t('screens:orderDetailsScreen.deliveryNotAvailableMsg')}</option>
                                    <option value="NOT_WITHIN_DELIVERY_AREA">{i18n.t('screens:orderDetailsScreen.notWithinDeliveryAreaMsg')}</option>
                                    <option value="PRODUCTS_UNAVAILABLE">{i18n.t('screens:orderDetailsScreen.productsUnavailableMsg')}</option>
                                    <option value="EQUIPMENT_FAILURE">{i18n.t('screens:orderDetailsScreen.equipmentFailureMsg')}</option>
                                    <option value='CANCELED_BY_STORE'>{i18n.t('screens:orderDetailsScreen.canceledByStore')}</option>
                                    <option value='CANCELED_BY_CUSTOMER'>{i18n.t('screens:orderDetailsScreen.canceledByCustomer')}</option>
                                </Input>
                            </Col>
                            <Col sm={2} style={noPadding}>
                                <Button color="primary" onClick={() => this.cancelOrder()} style={alignRight}>{i18n.t('screens:orderDetailsScreen.cancelOrder')}</Button>
                            </Col>
                        </Col>
                    </CardBody>
                </Card>
            </Col>
        );
    }

    cancelOrder() {
        const cancelReason = this.state.cancelRefundReason;
        const orderId = this.props.orderDetails.order.id;
        const restaurantId = this.props.restaurantId;
        const currentPageNumber = this.props.currentPageNumber;

        this.props.cancelOrder(cancelReason, orderId, restaurantId, currentPageNumber, () => {
            /** TODO handle multiple cases when this is refactored/optimized*/
            this.props.getOrdersDetails(orderId)
            // this.toggle();

            // if (this.props.searchQuery) {
            //     this.props.getOrdersCentral(0, this.props.searchQuery);
            // }
        });
    }

    renderReportProblem() {
        const { cancelOrderContainer, noPadding, alignInRow, reportProblemButton, problemDetailsLabel } = styles;
        const { order } = this.props.orderDetails;

        return (
            <Col xs={12} sm={12} md={12} style={cancelOrderContainer} >
                <AvForm onValidSubmit={(e) => this.reportOrderProblem(e, order)}>
                    <Card>
                        <CardBody>
                            <Col xs={12} sm={12} style={Object.assign({}, noPadding, alignInRow)}>
                                <Label md={1} sm={1} for="orderProblemDetails" style={problemDetailsLabel}>{i18n.t('screens:orderDetailsScreen.problemDetails')}</Label>
                                <AvGroup style={{ width: '80%' }} >
                                    <AvInput type="text" name="orderProblemDetails" id="orderProblemDetails"
                                        value={this.state.orderProblemDetails}
                                        onChange={this.changeState}
                                        required={true} />
                                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                                </AvGroup>
                                <Button color="primary" style={reportProblemButton}>{i18n.t('common:buttons.send')}</Button>
                            </Col>
                        </CardBody>
                    </Card>
                </AvForm>
            </Col>
        );
    }

    reportOrderProblem(e, selectedOrder) {
        e.preventDefault();

        const orderId = selectedOrder.id;
        const data = {
            attachments: [],
            subject: `${i18n.t('screens:orderDetailsScreen.orderSupport')}: #${orderId}`,
            body: this.state.orderProblemDetails
        };

        this.props.createTicket(data, () => {
            // this.toggle();
            this.props.getOrdersDetails(orderId)
        });
    }

    renderResendOrderConfirmation() {

        return (
            <Modal isOpen={this.state.resendOrderConfirmationModalOpened} toggle={this.toggleResendOrderConfirmationModal.bind(this)} size="md">
                <ModalHeader className="modalHeader" toggle={this.toggleResendOrderConfirmationModal.bind(this)}>{i18n.t('screens:orderDetailsScreen.resetOrderModalTitle')}</ModalHeader>
                <ModalBody>
                    <h6 style={{ marginBottom: 15 }} >{i18n.t('screens:orderDetailsScreen.resetOrderModalMessage')}</h6>
                    <Button
                        style={{ marginRight: 10, position: 'relative' }}
                        color="primary"
                        disabled={this.state.loading}
                        onClick={this.resendOrder.bind(this, this.state.resetOrderId)}
                    >
                        {i18n.t('common:buttons.confirm')}
                        {this.renderResetButtonLoader()}
                    </Button>
                    <Button onClick={this.toggleResendOrderConfirmationModal.bind(this)}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalBody>
            </Modal>
        );
    }

    renderResetButtonLoader() {
        if (!this.state.loading) return null;

        return (
            <div style={styles.loadingContainerTransparent}>
                    <div style={styles.loadingIndicator} className='text-center loadingIndicator'>
                        <GridLoader color="#0288d1" size={20} />
                    </div>
                </div>
        );
    }

    renderAcceptOrderConfirmation() {

        return (
            <Modal isOpen={this.state.acceptOrderConfirmationModalOpened} toggle={this.toggleAcceptOrderConfirmationModal.bind(this)} size="md">
                <ModalHeader className="modalHeader" toggle={this.toggleAcceptOrderConfirmationModal.bind(this)}>{i18n.t('screens:orderDetailsScreen.acceptOrderModalTitle')}</ModalHeader>
                <ModalBody>
                    <h6 style={{ marginBottom: 15 }} >{i18n.t('screens:orderDetailsScreen.acceptOrderModalMessage')}</h6>
                    <Button
                        style={{ marginRight: 10, position: 'relative' }}
                        color="primary"
                        disabled={this.state.loading}
                        onClick={this.acceptOrder.bind(this, this.state.acceptOrderId)}
                    >
                        {i18n.t('common:buttons.confirm')}
                    </Button>
                    <Button onClick={this.toggleAcceptOrderConfirmationModal.bind(this)}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalBody>
            </Modal>
        );
    }

    acceptOrder(orderId) {
        this.setState({ ...this.state, loading: true }, () => {

            this.props.manuallyAcceptOrder(orderId, () => {
                this.setState({ ...this.state, loading: false }, () => this.toggleAcceptOrderConfirmationModal());
                // this.props.refreshResults();
                this.props.getOrdersDetails(orderId);
            });
        });
    }

    renderExtraTimeInput() {
        return (
            <div style={{ display: 'flex', marginLeft: 10 }}>
                <Input type="select" name="extraTime" id="extraTime"
                    value={this.state.extraTime}
                    onChange={(e) => this.setState({ ...this.state, [e.target.name]: e.target.value })}>
                    {this.renderExtraTimeOptions()}
                </Input>
                <Button color="primary" onClick={this.onClickAddExtraTime} style={{ marginLeft: 5 }}>{i18n.t('screens:orderDetailsScreen.add')}</Button>
            </div>
        )
    }

    onClickAddExtraTime() {
        this.props.addExtraTime(this.props.orderDetails.order.id, this.state.extraTime);
        this.setState({ ...this.state, addExtraTime: false });
    }

    renderExtraTimeOptions() {
        let minutes = []
        for (let i = 5; i <= 40; i += 5) {
            minutes.push(i);
        }

        return minutes.map(minute => <option value={minute}>{`${minute} minutes`}</option>);
    }

    renderPaymentTypeIconStyle(paymentTypeId) {

        if (paymentTypeId) {
            switch (paymentTypeId) {
                case 1:
                    return ({ position: 'relative', top: 5, left: 3 })
                    break;
                case 2:
                    return ({ position: 'relative', top: 5, left: 4 })
                    break;
                case 3:
                    return ({ position: 'relative', top: 8, left: 4 })
                    break;
                default:
                    return {}
            }
        } else {
            return {}
        }

    }

    render() {
        if (this.props.orderDetails.order && Object.keys(this.props.orderDetails.order).length <= 0) return <div />;

        const { labelStyle, spanStyle, orderTypeIcon, paymentTypeIcon, screenTitleContainer } = styles;
        const { order } = this.props.orderDetails;
        let orderStatus = (order.status !== null) ? i18n.t(`screens:orderHistoryScreen.${order.status.toLowerCase()}`) : i18n.t(`screens:orderHistoryScreen.noStatus`);

        if (this.state.rejectedOrderStatusReceived) orderStatus = i18n.t(`screens:orderHistoryScreen.${this.state.rejectedOrderStatusReceived.toLowerCase()}`);

        let orderStatusColor = RestaurantUtils.getOrderStatusColor(order.status);

        if (this.state.rejectedOrderStatusReceived) orderStatusColor = RestaurantUtils.getOrderStatusColor(this.state.rejectedOrderStatusReceived);

        const customer = order.customer;
        const orderAddress = order.orderAddress;
        const address = (orderAddress.fullAddress !== null) ? orderAddress.fullAddress : orderAddress.street + ', ' + orderAddress.city + ', ' + localizeCountryNames(orderAddress.country)
        const orderTypeIconSrc = renderOrderTypeSrc(order.orderType.id);
        let paymentTypeIconSrc = renderPaymentTypeIcon(order.tenderType.id);

        const orderType = (order.orderType.id == COLLECTION_ID) ? 'Collection' : (order.orderType.id == DELIVERY_ID) ? 'Delivery' : order.orderType.id === INSTORE_ID ? 'Dine Pay' : '';
        const paymentTypeValue = order.tenderType.value.replace(/\s/g, '');


        const collectionAddress = i18n.t('screens:orderDetailsScreen.collectionAddress');
        const deliveryAddress = i18n.t('screens:orderDetailsScreen.deliveryAddress');
        let orderAddressText = (order.orderType.id == COLLECTION_ID) ? collectionAddress : (order.orderType.id == DELIVERY_ID) ? deliveryAddress : '';
        if (order.orderType.id === INSTORE_ID) {
            orderAddressText = `${order.orderInStoreInfo.label}: `;
        }
        const isRefundHidden = (order.tenderType.id == CASH_ID || order.status == 'CANCELED' || order.status == 'REFUNDED' || maxRefundAmount == 0) ? true : false;
        const isRefundHistoryHidden = (order.tenderType.id == CASH_ID) ? true : false;
        const isCancelOrderHidden = (order.status == 'CANCELED') ? true : false;
        const refunds = this.props.orderDetails.refunds;
        const orderTotal = order.total;
        const maxRefundAmount = getMaxRefundAmount(orderTotal, refunds);
        const orderServiceFee = order.serviceFee ? order.serviceFee : 0;
        let price = parseFloat(order.total) + orderServiceFee;
        let renderLoyaltyIcon = order.paidWithVoucher;

        const isOnlyLoyalty = renderLoyaltyIcon && price === 0 ? true : false;

        if (isOnlyLoyalty) {
            paymentTypeIconSrc = null;
        }
        
        const loyaltyIconStyle = this.renderPaymentTypeIconStyle(3);
        const loyaltyIconSrc = renderPaymentTypeIcon(3, loyaltyIconStyle, isOnlyLoyalty); // Loyalty fake id

        return (
            <div style={{ margin: 30 }}>
                {
                    this.props.orderDetails.order.deleted ?
                        <Row>
                            <Col>
                                <p>* {i18n.t('screens:orderHistoryScreen.containsDelProducts')}</p>
                            </Col>
                        </Row> : null
                }

                <Row>
                    <Col xs={6} sm={6} md={6} style={{}}>
                        <p style={labelStyle}>{i18n.t('screens:orderHistoryScreen.orderIdTable')}<span style={spanStyle}> {order.id}</span></p>
                        <p style={labelStyle}>{i18n.t('screens:orderDetailsScreen.orderStatus')}
                            <span style={{ color: orderStatusColor }}>{orderStatus}</span>
                            <Button
                                style={{ marginLeft: 10 }}
                                color="primary"
                                hidden={orderStatus.toUpperCase() !== REJECTED || this.props.orderDetails.order.deleted}
                                onClick={this.toggleResendOrderConfirmationModal.bind(this, order.id)}
                            >
                                {i18n.t('screens:orderDetailsScreen.resendOrder')}
                            </Button>
                            <Button
                                style={{ marginLeft: 10 }}
                                color="primary"
                                hidden={orderStatus.toUpperCase() !== REJECTED || this.props.orderDetails.order.deleted}
                                onClick={this.toggleAcceptOrderConfirmationModal.bind(this, order.id)}
                            >
                                {i18n.t('screens:orderDetailsScreen.acceptOrder')}
                            </Button>
                        </p>
                        <p style={labelStyle}>{i18n.t('screens:orderDetailsScreen.orderType')}
                            <span>{orderTypeIconSrc} <span style={spanStyle}>{orderType === 'Collection' ? i18n.t('screens:orderDetailsScreen.pickUp') : orderType}</span>
                            </span>
                        </p>
                        <p style={{ ...labelStyle, display: 'flex', alignItems: 'center' }}><span style={{marginRight: 4}}>{i18n.t('screens:orderDetailsScreen.dateTime')}:</span>
                                <span style={spanStyle}>{order.wantedTime}</span>
                            <Button
                                style={{ marginLeft: 10 }}
                                color="primary"
                                hidden={((orderStatus.toUpperCase() !== ACCEPTED && orderStatus.toUpperCase() !== ACEPTADO) && !this.state.addExtraTime) || this.state.addExtraTime}
                                onClick={() => this.setState({ ...this.state, addExtraTime: true })}
                            >
                                {i18n.t('screens:orderDetailsScreen.addExtraTime')}
                            </Button>
                            {this.state.addExtraTime ? this.renderExtraTimeInput() : null}
                        </p>
                        {
                            order.rejectReason ?
                                <p style={labelStyle}>{i18n.t('screens:orderDetailsScreen.rejectReason')}:
                                        <span style={spanStyle}> {i18n.t(`screens:mainContainer.${order.rejectReason}`)}</span>
                                </p> : null
                        }
                        <p style={labelStyle}>Source: <OrderSourceSelector source={order.source} /></p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                        <p style={labelStyle}>{i18n.t('screens:orderHistoryScreen.customerName')}: <span
                            style={spanStyle}> {customer.name}</span></p>
                        <p style={labelStyle}>{orderAddressText}<span
                            style={spanStyle}> {order.orderType.id === INSTORE_ID ? order.orderInStoreInfo.value : order.orderType.id === CURBSIDE_ID ? order.carDetails : address}</span>
                        </p>
                        <p style={labelStyle}>{i18n.t('screens:orderDetailsScreen.paymentType')}

                            {renderLoyaltyIcon && paymentTypeIconSrc ?
                                <React.Fragment>
                                    <span style={spanStyle}>{paymentTypeIconSrc}</span>
                                    <span style={spanStyle}>{i18n.t(`screens:orderDetailsScreen.${paymentTypeValue}`)}</span>
                                    <span style={spanStyle}> + </span>
                                    {loyaltyIconSrc}
                                    <span style={spanStyle}> {i18n.t('screens:restaurantsMainContainer.loyalty')}</span>
                                </React.Fragment> :
                                renderLoyaltyIcon && !paymentTypeIconSrc ?

                                    <React.Fragment>
                                        {loyaltyIconSrc}
                                        <span style={spanStyle}> {i18n.t('screens:restaurantsMainContainer.loyalty')}</span>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <span>{paymentTypeIconSrc}</span>
                                        <span style={spanStyle}>{i18n.t(`screens:orderDetailsScreen.${paymentTypeValue}`)}</span>
                                    </React.Fragment>
                            }
                        </p>
                        <p style={{ ...labelStyle, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                color="primary"
                                onClick={() => this.props.getOrderAsPdf(this.props.orderDetails.order.id)}
                            >
                                {i18n.t('screens:orderDetailsScreen.printOrder')}
                            </Button>
                        </p>
                    </Col>
                </Row>
                {/* <Col xs={12} sm={12} md={12} style={{ marginBottom: 0 }}>
                            <Button color="link" style={seeMoreButton} onClick={this.toggleOrderDetailsInfo}>
                                See More
                                <MaterialIcon icon={this.state.seeMoreIcon} color="#0288d1" />
                            </Button>
                        </Col> */}
                {/* {this.renderSeeMoreContent()} */}
                <Row style={{ marginBottom: 20 }}>
                    {this.renderCustomerDetails()}
                    {this.renderRestaurantDetails()}
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={12}>
                        <Col xs={3} style={screenTitleContainer}>
                            <div><MaterialIcon icon="shopping_cart" color="#0288d1" />{i18n.t('screens:orderDetailsScreen.productDetails')}</div>
                        </Col>
                        {this.renderProductsDetails()}
                    </Col>
                    <Col xs={12} sm={12} md={12}>
                        <Col xs={3} style={screenTitleContainer}>
                            <div><MaterialIcon icon="shopping_cart" color="#0288d1" />{i18n.t('screens:orderDetailsScreen.orderDetails')}</div>
                        </Col>
                        {this.renderOrderDetails()}
                    </Col>
                    <Col xs={12} sm={12} md={12}>
                        <Col xs={3} style={screenTitleContainer} hidden={isRefundHidden}>
                            <div><MaterialIcon icon="attach_money" color="#0288d1" />{i18n.t('screens:orderDetailsScreen.refundDetails')}</div>
                        </Col>
                        {this.renderRefundDetails()}
                    </Col>
                    <Col xs={12} sm={12} md={12}>
                        <Col xs={3} style={screenTitleContainer} hidden={isRefundHistoryHidden}>
                            <div><MaterialIcon icon="history" color="#0288d1" />{i18n.t('screens:orderDetailsScreen.refundHistory')}</div>
                        </Col>
                        {this.renderRefundHistoryDetails()}
                    </Col>
                    <Col xs={12} sm={12} md={12}>
                        <Col xs={3} style={screenTitleContainer} hidden={isCancelOrderHidden}>
                            <div><MaterialIcon icon="clear" color="#0288d1" /> &nbsp;{i18n.t('screens:orderDetailsScreen.cancelOrder')}</div>
                        </Col>
                        {this.renderCancelOrder()}
                    </Col>
                    <Col xs={12} sm={12} md={12}>
                        <Col xs={3} style={screenTitleContainer}>
                            <div><MaterialIcon icon="headset_mic" color="#0288d1" />{i18n.t('screens:orderDetailsScreen.contactSupport')}</div>
                        </Col>
                        {this.renderReportProblem()}
                    </Col>
                </Row>
                {this.renderResendOrderConfirmation()}
                {this.renderAcceptOrderConfirmation()}
            </div>
        );
    }
}

export default OrderDetailsContent;

const styles = {
    screenTitleContainer: {
        borderBottom: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: 'blue',
        alignSelf: 'flex-start',
        borderColor: 'rgb(222, 226, 230)',
        paddingLeft: 0,
        marginTop: 15,
        marginBottom: 5,
        color: '#0288d1'
    },
    labelStyle: { color: 'grey' },
    spanStyle: { color: '#000' },
    orderTypeIcon: { marginBottom: 5, marginLeft: 10, marginRight: 5 },
    paymentTypeIcon: { marginBottom: 6, marginLeft: 10, marginRight: 5 },
    textAlignCenter: { textAlign: 'center' },
    instructionsStyle: { color: 'grey', fontSize: 14, marginBottom: 2 },
    discountTh: { fontSize: '15.5px', position: 'relative', top: 1 },
    alignLeft: { float: 'left' },
    refundDetailsContainer: { paddingLeft: 0, float: 'left', marginBottom: 15, marginRight: -15 },
    negativeMarginRight: { marginRight: -15 },
    noLeftRightMargin: { marginLeft: 0, marginRight: 0 },
    totalPriceContainer: { float: 'left', paddingLeft: 0, paddingRight: 0 },
    totalPriceLabel: { color: 'grey', paddingTop: 10 },
    refundTypeContainer: { float: 'left', paddingLeft: 0, display: 'flex', marginLeft: -10, marginRight: 10 },
    priceStyle: { color: '#000', marginLeft: 10 },
    refundTypeLabel: { color: 'grey', paddingTop: 10, float: 'left', width: '100%' },
    refundValueContainer: { float: 'left', paddingLeft: 0, display: 'flex' },
    refundValueLabel: { color: 'grey', paddingTop: 10, float: 'left', width: '100%' },
    refundReasonContainer: { marginLeft: 0, marginRight: 0, marginTop: 20 },
    refundReasonColumn: { float: 'left', paddingLeft: 0, paddingRight: 0, display: 'flex' },
    refundReasonLabel: { color: 'grey', paddingTop: 10, width: '30%' },
    cancelOrderContainer: { paddingLeft: 0, paddingRight: 0, float: 'left', marginBottom: 15 },
    cardBodyMainColumn: { paddingLeft: 0, display: 'flex' },
    cancelRefundReasonColumn: { float: 'left', paddingLeft: 0, paddingRight: 0, display: 'flex' },
    leftAlignedLabel: { color: 'grey', paddingTop: 10, float: 'left', width: '40%' },
    alignRight: { float: 'right' },
    noPadding: { padding: 0 },
    alignInRow: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'row'
    },
    reportProblemButton: {
        marginLeft: 12
    },
    problemDetailsLabel: {
        padding: '10px 0px',
        color: 'grey'
    },
    loadingIndicator: {
        width: '72px',
        height: '72px',
    },
    loadingContainerTransparent: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        textAlign: 'center',
        verticalAlign: 'middle',
        zIndex: 100000000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/orders/OrderDetailsContent.js